// src/footerConfigs.js

export const footerConfigs = {
  "bheema": {
  brandName: "Little Wonders School,Navnagar",
    contact: "+91 72044 21280 | sneflittlewonders.2024@gmail.com",
    socialLinks: {
      instagram: "https://www.instagram.com/littlewonders___32/?utm_source=qr&igsh=NHpmeHlrcTgzdzVw#",
      whatsapp:   "https://wa.me/yourwhatsapplink",
      youtube:    "https://www.youtube.com/@littlewonders19",
      facebook:   "https://www.facebook.com/61558050719750/about/?_rdr",
      twitter:    "https://twitter.com"
    }
  },

  "acmeCorp": {
    brandName: "ACME Corporation",
    contact: "1800-ACME | support@acme.com",
    socialLinks: {
      instagram: "https://instagram.com/acmecorp",
      whatsapp:   "",
      youtube:    "https://youtube.com/acmecorp",
      facebook:   "https://facebook.com/acmecorp",
      twitter:    "https://twitter.com/acmecorp"
    }
  }

  // add more customer configs here...
};
